// file for storing the query keys used by @tanstack/react-query

export const queryKeys = {
  user: 'user',
  users: 'users',
  leaderboard: 'leaderboard',
  banner: 'banner',
  bowlingCenter: 'bowlingCenter',
  allBowlingCenters: 'allBowlingCenters',
  finishedGames: 'finishedGames',
  topScores: 'topScores',
};
